export default __webpack_public_path__ + "static/media/8.0122c2c9.png";